export default __webpack_public_path__ + "static/force-usa-cover-small-3ea7bb9e56e32a08bb3aace9fc412b5a.webp";